export default "__VITE_ASSET__DYSlCd04__"